import usePendingState from '../../Hooks/usePendingState';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';
import { InputFileImage } from './InputFileImage';

const FormAddSlide = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [slideData, setSlideData] = useState({
        chamada: '',
        botao: '',
        img: '',
        img_mobile: '',
    });

    const [slideErrorData, setslideErrorData] = useState({
        chamada: [],
        botao: [],
        img: [],
        img_mobile: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const { id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSlideData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleImageCrop = (croppedImage, fileExtenstion, name) => {
        setSlideData((prevData) => ({
            ...prevData,
            [name]: croppedImage === '' ? null : croppedImage,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const formData = new FormData();

            Object.keys(slideData).forEach((key) => {
                if (key !== 'img' || key !== 'img_mobile') {
                    if (typeof slideData[key] === 'boolean') {
                        formData.append(key, slideData[key] ? 1 : 0);
                    } else {
                        formData.append(key, slideData[key]);
                    }
                }
            });

            if (slideData.img) {
                formData.append('img', slideData.img);
            }

            if (slideData.img_mobile) {
                formData.append('img_mobile', slideData.img_mobile);
            }

            const response = await fetch(`${baseUrl}/manager/slides/atualizar/${id}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Slide atualizado com sucesso!',
                    show: true,
                });
                navigate('/manager/');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();

                    setslideErrorData(errors);
                } else {
                    throw new Error('Erro ao atualizar slide.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const [slideResponse] = await Promise.all([
                    fetch(`${baseUrl}/manager/slides/${id}`, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            'Content-Type': 'application/json',
                        },
                    }),
                ]);

                if (slideResponse.ok) {
                    const slideData = await slideResponse.json();
                    setSlideData(slideData.slide || []);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, []);

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <>
            <Link
                to="/manager"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Adicionar slide</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Chamada</label>
                                <textarea
                                    name="chamada"
                                    value={slideData.chamada}
                                    onClick={() => setslideErrorData((prevData) => ({ ...prevData, chamada: [] }))}
                                    onChange={handleChange}
                                    rows="4"
                                    className="w-full px-3 py-1.5 2xl:py-2 resize-none border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {slideErrorData.chamada && slideErrorData.chamada[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {slideErrorData.chamada[0]}{' '}
                                        <span
                                            onClick={() => setslideErrorData((prevData) => ({ ...prevData, chamada: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Texto botão</label>
                                <input
                                    type="text"
                                    name="botao"
                                    value={slideData.botao}
                                    onClick={() => setslideErrorData((prevData) => ({ ...prevData, botao: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {slideErrorData.botao && slideErrorData.botao[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {slideErrorData.botao[0]}{' '}
                                        <span
                                            onClick={() => setslideErrorData((prevData) => ({ ...prevData, botao: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium">Imagem desktop</label>

                                <InputFileImage
                                    name="img"
                                    imagem={slideData.imagem}
                                    size={{ largura: '1920', altura: '680' }}
                                    allowCrop={true}
                                    onImageCrop={handleImageCrop}
                                />
                                {slideErrorData.img && slideErrorData.img[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {slideErrorData.img[0]}{' '}
                                        <span
                                            onClick={() => setslideErrorData((prevData) => ({ ...prevData, img: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/2">
                                <label className="block text-sm font-medium">Imagem mobile</label>

                                <InputFileImage
                                    name="img_mobile"
                                    imagem={slideData?.img_mobile ?? `/assets/img/admin/image-select.png`}
                                    // imagem={`/assets/img/admin/image-select.png`}
                                    size={{ largura: '1080', altura: '655' }}
                                    allowCrop={true}
                                    onImageCrop={handleImageCrop}
                                />
                                {slideErrorData.img_mobile && slideErrorData.img_mobile[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {slideErrorData.img_mobile[0]}{' '}
                                        <span
                                            onClick={() => setslideErrorData((prevData) => ({ ...prevData, img_mobile: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};

export default FormAddSlide;
